const moment = require("moment");

const day = [
  { no: 0, long: "Sunday", short: "Sun" },
  { no: 1, long: "Monday", short: "Mon" },
  { no: 2, long: "Tuesday", short: "Tue" },
  { no: 3, long: "Wednesday", short: "Wed" },
  { no: 4, long: "Thursday", short: "Thu" },
  { no: 5, long: "Friday", short: "Fri" },
  { no: 6, long: "Saturday", short: "Sat" },
];

const month = [
  { no: 1, long: "January", short: "Jan" },
  { no: 2, long: "February", short: "Feb" },
  { no: 3, long: "March", short: "Mar" },
  { no: 4, long: "April", short: "Apr" },
  { no: 5, long: "May", short: "May" },
  { no: 6, long: "June", short: "Jun" },
  { no: 7, long: "July", short: "Jul" },
  { no: 8, long: "August", short: "Aug" },
  { no: 9, long: "September", short: "Sep" },
  { no: 10, long: "October", short: "Oct" },
  { no: 11, long: "November", short: "Nov" },
  { no: 12, long: "December", short: "Dec" },
];
function dayFunction(n) {
  return day.find((_n) => _n.no == n);
}
function monthFunction(n) {
  return month.find((_n) => _n.no == n);
}

export function listMonth() {
  return month;
}

export function manualDateToUnix(day, month, year) {
  let n = moment(day + "/" + month + "/" + year, "DD/MM/YYYY").unix();
  return { valid: !isNaN(n), unix: n };
}
export function unixToDateManual(unix) {
  return {
    d: moment.unix(unix).format("D"),
    m: moment.unix(unix).format("M"),
    y: moment.unix(unix).format("Y"),
  };
}

export function unixToDDMMMMYYYY(unixtime) {
  // console.log("test", monthFunction(14));
  let M = monthFunction(moment.unix(unixtime).format("M")).long;
  let Y = moment.unix(unixtime).format("Y");
  let D = moment.unix(unixtime).format("DD");
  return D + " " + M + " " + Y;
}

export function unixToDDMMMYYYY(unixtime) {
  // console.log("test", monthFunction(14));
  let M = monthFunction(moment.unix(unixtime).format("M")).short;
  let Y = moment.unix(unixtime).format("Y");
  let D = moment.unix(unixtime).format("DD");
  return D + " " + M + " " + Y;
}

export function unixToDDMMYYYY(unixtime) {
  // console.log("test", monthFunction(14));
  let M = moment.unix(unixtime).format("MM");
  let Y = moment.unix(unixtime).format("Y");
  let D = moment.unix(unixtime).format("DD");
  return D + "/" + M + "/" + Y;
}
export function stringDifferentFromNow(dateString) {
  return unixDifferentFromNow(moment(dateString).unix());
}
export function unixDifferentFromNow(unixtime) {
  let nw = moment();
  let bw = moment.unix(unixtime);

  if (nw.diff(bw, "seconds") <= 60) {
    return nw.diff(bw, "seconds") + " seconds ago";
  }
  if (nw.diff(bw, "minutes") <= 60) {
    return nw.diff(bw, "minutes") + " minutes ago";
  }
  if (nw.diff(bw, "hours") <= 24) {
    return nw.diff(bw, "hours") + " hours ago";
  }

  if (nw.diff(bw, "days") <= 7) {
    return nw.diff(bw, "days") + " days ago";
  }
  if (nw.diff(bw, "weeks") <= 5) {
    return nw.diff(bw, "weeks") + " weeks ago";
  }
  if (nw.diff(bw, "months") <= 12) {
    return nw.diff(bw, "months") + " months ago";
  }
  if (nw.diff(bw, "years") >= 1) {
    return nw.diff(bw, "years") + " years ago";
  }
  console.log("nw", nw, nw.diff(bw, "minutes") <= 60);
  return "-";
}

export function unixToDayDDMMMMYYYY(unixtime) {
  // console.log("unixtime", unixtime);
  if (unixtime.toString().length > 10) {
    unixtime = unixtime / 1000;
  }
  let Day = dayFunction(moment.unix(unixtime).day())?.long;
  let M = monthFunction(moment.unix(unixtime).format("M")).long;
  let Y = moment.unix(unixtime).format("Y");
  let D = moment.unix(unixtime).format("DD");
  return Day + ", " + D + " " + M + " " + Y;
}

export function unixToFullDateTime(unixtime) {
  let Clock = moment.unix(unixtime).format("HH:mm");

  return Clock + " " + unixToDDMMMMYYYY(unixtime);
}

export function unixTime(unixtime) {
  let Clock = moment.unix(unixtime).format("HH:mm");

  return Clock;
}

export function unixDurationDate(startDate, endDate) {
  let dStart = moment.unix(startDate);
  let dEnd = moment.unix(endDate);
  return dEnd.diff(dStart, "days");
}

export function arrayUnixDurationDate(startDate, endDate) {
  var dateArray = new Array();
  let dStart = moment.unix(startDate);
  let dEnd = moment.unix(endDate).add(1, "days");
  var currentDate = dStart;
  while (currentDate <= dEnd) {
    dateArray.push(currentDate.unix());
    currentDate = currentDate.add(1, "days");
  }
  return dateArray;
}

export function momentToDDMMMMYYYY(momentFormat) {
  let M = monthFunction(momentFormat.format("M")).long;
  let Y = momentFormat.format("Y");
  let D = momentFormat.format("DD");
  return D + " " + M + " " + Y;
}

export function unixGetDurationOfOnaDay(dateUnix) {
  // PEROMBAKAN
  let x = moment.unix(dateUnix).format("YYYY-MM-DD");
  let offset = dateOffsetUser();
  // if (offset > 0) {
  //   return moment(x)
  //     .add(-dateOffsetUser() + 720, "minutes")
  //     .unix();
  // }

  // return {
  //   startDay: moment(

  //     moment.unix(dateUnix).format("MM/DD/YYYY") + " 00:01",
  //     "MM/DD/YYYY HH:mm"
  //   ).unix(),
  //   endDay: moment(
  //     moment.unix(dateUnix).format("MM/DD/YYYY") + " 23:59",
  //     "MM/DD/YYYY HH:mm"
  //   ).unix(),
  // };
  if (offset > 0) {
    return {
      startDay: moment(x)
        .add(-offset + 720, "minutes")
        .unix(),
      endDay: moment(x)
        .add(-offset + 720 + 1439, "minutes")
        .unix(),
    };
  }
  return {
    startDay: moment(x).add(Math.abs(offset), "minutes").unix(),
    endDay: moment(x)
      .add(Math.abs(offset) + 1439, "minutes")
      .unix(),
  };
}

export function gmtClient() {
  let g = moment().format("Z");
  return (
    "GMT" +
    g.replace("30", "").replace("00", "").replace(":", "").replace("0", "")
  );
}

export function getOlder(unixdate) {
  let n = moment().diff(moment.unix(unixdate), "years");
  return n;
}

export function nth(d) {
  if (d > 3 && d < 21) return "th";
  switch (d % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}

const DATE_GLOBAL = new Date();
export function dateOffsetUser() {
  return DATE_GLOBAL.getTimezoneOffset();
}

export function dateUnixGMTBalance(d) {
  //inputan unix user menjadi epoc +0, kecuali minus jadi GMT-12
  let x = moment.unix(d).format("YYYY-MM-DD");
  let offset = dateOffsetUser();
  if (offset > 0) {
    return moment(x)
      .add(-dateOffsetUser() + 720, "minutes")
      .unix();
  }
  return moment(x).add(Math.abs(dateOffsetUser()), "minutes").unix();
}

export function dateForBugDatePick(d) {
  // inputan tanggal (YYMMDD) user menjadi epoc +0 pada datepicker select
  // console.log("start date offset", dateOffsetUser());
  let x = moment.unix(d).format("YYYY-MM-DD");
  let offset = dateOffsetUser();
  if (offset > 0) {
    return moment(x)
      .add(dateOffsetUser(), "minutes")
      .format("YYYY-MM-DD HH:mm:ss");
  }
  return moment(x).format("YYYY-MM-DD");
}

export function datetimeToUnix(D, M, YYYY, H, mm) {
  return moment(
    D + "-" + M + "-" + YYYY + " " + H + ":" + mm,
    "D-M-YYYY H:mm"
  ).unix();
}

export function unixToDDMMYYYYObj(unixtime) {
  // console.log("test", monthFunction(14));
  let M = moment.unix(unixtime).format("MM");
  let Y = moment.unix(unixtime).format("Y");
  let D = moment.unix(unixtime).format("DD");
  let H = moment.unix(unixtime).format("H");
  let mm = moment.unix(unixtime).format("mm");
  return { D, M, Y, H, mm };
}

export const validClock = (n) => {
  let reg = new RegExp("^([0-1]?[0-9]|2[0-3])$");
  return reg.test(n);
};
export const validMinute = (n) => {
  let reg = new RegExp("^([0-5]?[0-9])$");
  return reg.test(n);
};

export function durationTime(startUnix) {
  const now = moment(); // create a moment with the current time
  const then = moment.unix(startUnix); // create a moment with the other time timestamp in seconds
  const delta = now.diff(then, "second"); // get the millisecond difference

  return secsToTime(delta);
}

function secsToTime(secs) {
  let d = (secs / 8.64e4) | 0;
  let H = ((secs % 8.64e4) / 3.6e3) | 0;
  let m = ((secs % 3.6e3) / 60) | 0;
  let s = secs % 60;
  let z = (n) => (n < 10 ? "0" : "") + n;
  return `${z(H)}:${z(m)}:${z(s)}`;
}
